/**
 * Статические типы продаж для фильтров отчётов
 */
export type SaleTypeItem = {
  id: 'personal' | 'complex'
  title: string
}

export const saleTypes: Array<SaleTypeItem> = [
  { id: 'personal', title: 'Личные продажи' },
  { id: 'complex', title: 'Комплексное питание' },
]
